import { useAuthState } from './useAuthState';

/** Passkeys only work at one exact address. Warn if this isn't it. */
export function WrongAddressNotice() {
  const state = useAuthState();
  if (!state.data || state.data.appOrigin === window.location.origin) return null;
  const correct = state.data.appOrigin;
  return (
    <div className="notice" role="alert" data-testid="wrong-address">
      <strong>Wrong address.</strong> You're on {window.location.origin}. Signing in only works at{' '}
      <a href={correct}>{correct}</a>.
    </div>
  );
}
